var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnClose2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.8248 5.025C12.0598 4.79 12.0598 4.41 11.8248 4.1775C11.5898 3.945 11.2098 3.9425 10.9773 4.1775L8.00229 7.1525L5.02479 4.175C4.78979 3.94 4.40979 3.94 4.17729 4.175C3.94479 4.41 3.94229 4.79 4.17729 5.0225L7.15229 7.9975L4.17479 10.975C3.93979 11.21 3.93979 11.59 4.17479 11.8225C4.40979 12.055 4.78979 12.0575 5.02229 11.8225L7.99729 8.8475L10.9748 11.825C11.2098 12.06 11.5898 12.06 11.8223 11.825C12.0548 11.59 12.0573 11.21 11.8223 10.9775L8.84729 8.0025L11.8248 5.025Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnClose2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "7154f08e1b0f3484382a27b3ffb373d6.svg";